import { z } from 'zod'
export const deleteTagSchema = z.object({
  presentationId: z.string(),
  tag: z.string(),
})
export type DeleteTag = z.infer<typeof deleteTagSchema>
